import Image from "next/image";
import { type UserDetailsFragment } from "@/gql/graphql";

type Props = {
	user: UserDetailsFragment;
};

export const UserAvatar = ({ user }: Props) => {
	const label =
		user.firstName && user.lastName
			? `${user.firstName.slice(0, 1)}${user.lastName.slice(0, 1)}`
			: user.email.slice(0, 2);

	if (user.avatar) {
		return (
			<Image
				className="border-foreground/[0.08] h-[38px] w-[38px] rounded-full border"
				aria-hidden="true"
				src={user.avatar.url}
				width={38}
				height={38}
				alt=""
			/>
		);
	}

	return (
		<span
			className="border-foreground/[0.08] bg-primary/10 flex h-[38px] w-[38px] items-center justify-center rounded-full border text-center text-xs font-bold uppercase text-foreground"
			aria-hidden="true"
		>
			{label}
		</span>
	);
};
